import React from 'react';
import ModeSelector from './ModeSelector';

function ChatEmptyState({
  t,
  variant = 'no-client',
  showModeSelector = false,
  hideTitle = false,
  hideDescription = false,
  activeMode,
  onFreeForm,
  onBeTheClient,
  onOars,
  onStrategies,
  singleColumnEmptyPrompt = '',
}) {
  return (
    <div className={`chat-empty-state ${variant === 'selected' ? 'embedded' : 'entrance'}`}>
      <div className="chat-empty-copy">
        {!hideTitle && (
          <h2>
            {variant === 'client-mode'
              ? t('mode_btc')
              : t('mode_free_form')}
          </h2>
        )}
        {!hideDescription && (
          variant === 'no-client' ? (
            <p>{t('welcome_no_client')}</p>
          ) : variant === 'client-mode' ? (
            <p>{t('welcome_client_mode')}</p>
          ) : (
            <p>{t('welcome_selected')}</p>
          )
        )}
        {singleColumnEmptyPrompt && (
          <p className="chat-empty-single-column-prompt">{singleColumnEmptyPrompt}</p>
        )}
      </div>
      {showModeSelector && (
        <div className="chat-empty-mode-selector-shell">
          <ModeSelector
            modeBarVisible
            setModeBarVisible={() => {}}
            activeMode={activeMode}
            onFreeForm={onFreeForm}
            onBeTheClient={onBeTheClient}
            onOars={onOars}
            onStrategies={onStrategies}
            variant="inline"
          />
        </div>
      )}
    </div>
  );
}

export default ChatEmptyState;
